import { MessagingPlatform, UserCommunication } from '@this+that/models';
import type { TFunction } from 'i18next';
import log from 'loglevel';

import { IntegrationAccount } from '../models/integrationAccount';

export const getHomeAccountId = (
  emailAddress: string,
  integrationAccounts: IntegrationAccount[],
): string => {
  const account = integrationAccounts.find(
    (acc) =>
      acc.displayName === emailAddress || acc.identifier === emailAddress,
  );

  if (!account) {
    log.warn(
      `getHomeAccountId: No integration account found for email "${emailAddress}". Falling back to emailAddress which may not be a valid homeAccountId.`,
    );
  }

  return account?.identifier || emailAddress;
};

const PLATFORM_NAME_KEYS: Partial<Record<MessagingPlatform, string>> = {
  [MessagingPlatform.GOOGLE]: 'inbox.userCommunication.platformNames.google',
  [MessagingPlatform.GMAIL]: 'inbox.userCommunication.platformNames.gmail',
  [MessagingPlatform.OUTLOOK]: 'inbox.userCommunication.platformNames.outlook',
  [MessagingPlatform.SLACK]: 'inbox.userCommunication.platformNames.slack',
  [MessagingPlatform.TEAMS]: 'inbox.userCommunication.platformNames.teams',
  [MessagingPlatform.INSTAGRAM]:
    'inbox.userCommunication.platformNames.instagram',
};

export const getPlatformDisplayName = (
  t: TFunction,
  platform?: MessagingPlatform,
): string => {
  const key = platform ? PLATFORM_NAME_KEYS[platform] : undefined;
  return key ? t(key) : '';
};

export const getAccountDisplayName = (
  t: TFunction,
  integrationAccounts: IntegrationAccount[],
  userCommunication: UserCommunication,
): string => {
  const account = integrationAccounts.find(
    (acc) =>
      acc.identifier === userCommunication.userEmailAddress ||
      acc.displayName === userCommunication.userEmailAddress,
  );

  if (account) {
    return account.displayName;
  }

  log.warn(
    `getAccountDisplayName: No integration account found for "${userCommunication.userEmailAddress}". Falling back to platform name.`,
  );

  return getPlatformDisplayName(t, userCommunication.platform);
};
